import {useEffect} from "react";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router";
import {ApplicationPaths, navigateToStep} from "../ApplicationFormsHelpers";
import {useApplicationIdContext} from "../../components/ApplicationContext";
import {trackEcommerceEvent} from "../../lib/gtm";
import {
    pollForExpectedSignState, submitSsnToGetGpid,
} from "../../services/legacyApplicationApiService";
import {
    Headline,
    HtmlContainer,
} from "../../ui";
import {SignCommonComponent, useApplicationSignContext} from "../../components/Sign/SignCommon";
import style from "./style.module.scss";
import {CommonStatusPageProps} from "@n2-common/components/ApplicationStatusPage";

export function SignCompletedPage({navigateToCorrectStepFunc}: CommonStatusPageProps): JSX.Element {
    return <SignCommonComponent navigateToCorrectStepFunc={navigateToCorrectStepFunc}>
        <SignCompletedInner/>
    </SignCommonComponent>
}

function SignCompletedInner(): JSX.Element {
    const navigate = useNavigate();

    const {t} = useTranslation("common");
    const {applicantId, applicationId, isMainApplicant} = useApplicationSignContext();
    const {country, productType} = useApplicationIdContext();
    const {applicationStatus} = useApplicationSignContext();

    useEffect(() => {   
        if (applicationStatus) {

            pollForExpectedSignState(applicationId,
                (res) => {
                    return isMainApplicant ? res.MainApplicantHasSigned : res.CoApplicantHasSigned
                }).then(() => {
                trackEcommerceEvent(productType, country, 'add_payment_info', applicationStatus?.OfferedAmount ?? 0, applicationStatus.Gpid?.toString(), applicationId, 'approved', applicationStatus?.HasPpi ?? undefined);
                navigateToStep(ApplicationPaths.sign, applicationId, navigate, applicantId);
            });
        }
    }, [applicationId, navigate, applicantId, isMainApplicant, productType, country, applicationStatus]);

    return (
        <>
        <span className={style.backButton}
              onClick={() =>
                  navigateToStep(ApplicationPaths.sign, applicationId, navigate, applicantId)
              }
        > {"< "}{t<string>('Navigation.Back')} </span>
            <div className={style.wrapper}>

                <Headline>{t<string>('ApplicationLandingPages.SignCompleted.Headline')}</Headline>
                <Headline level={3}>{t<string>('ApplicationLandingPages.SignCompleted.SubHeadline')}</Headline>
                <HtmlContainer innerHtml={t<string>('ApplicationLandingPages.SignCompleted.Body', '')}/>

            </div>
        </>
    );
}
